<p>An error occured while saving.</p>
<div *ngFor="let message of messages">
    <p>{{message}}</p>
</div>
